// 主页
<template>
  <div class="mainArea Index">欢迎登录极酷物联平台</div>
</template>

<script>

  export default {
    name: 'Index',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
    },
    watch: {
    },
  }
</script>

<style lang="scss" scoped>
.mainArea.Index {
    padding-top: 20%;
    text-align: center;
    font-size: 36px;
    // color: #03a9f4;
    color: #1890ff;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue